function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.667 3.667H3.129c.907-1.281 2.275-2 3.871-2A5.333 5.333 0 0 1 12.334 7h1.333A6.667 6.667 0 0 0 7 .333c-1.87 0-3.516.789-4.667 2.18V.334H1V5h4.667V3.667zm2.667 6.666h2.537c-.907 1.281-2.275 2-3.87 2A5.333 5.333 0 0 1 1.666 7H.333A6.667 6.667 0 0 0 7 13.667c1.87 0 3.517-.789 4.667-2.18v2.18H13V9H8.334v1.333z",
  fill: "currentColor"
});

const SvgSyncCircle = props => React.createElement("svg", _extends({
  viewBox: "0 0 14 14",
  fill: "none"
}, props), _ref);

export default SvgSyncCircle;